var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),(!_vm.checkTime())?_c('b-flix-p',[_c('b-flix-alert',{attrs:{"variant":"danger"}},[_vm._v(" Bitte überprüfen! ")])],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }